import React from 'react';
import AppLayout from '../../core/layouts/AppLayout';
import '../../styles/listing.scss';
import '../../styles/settings.scss';
import { TabNames } from './props';
import LeftMenu from './components/left-menu';
import VisibilityGroup from './tabs/visibility-group';
import VGOfOnlineUnassignedEntities from './tabs/online-unassigned-entities';
import OnlineLeads from './tabs/online-leads';
import { useDataLoader } from 'react-remote-data-hooks';
import { Settings } from '../../core';
import api from '../../api';
import { useMasterData } from '../../core/hooks/useMasterData';

const RolesAcceessibility: React.FunctionComponent = () => {
  const masterData = useMasterData(api.settings);
  const [tabName, setTabName] = React.useState<TabNames>(
    TabNames.VisibilityGroups
  );
  const handleTabChange = (tabNameValue: TabNames) => {
    setTabName(tabNameValue);
  };

  const { data: settings, reload } = useDataLoader<Settings>(() =>
    api.settings.getSettings()
  );

  const leadTypes = settings?.onlineLeadsVisibilityGroups?.leadTypes?.filter(
    (x) =>
      x.sourceofBusinesses?.filter((s) => !!s.sobVisibilityGroups?.length)
        ?.length === masterData?.data?.businessSources?.length
  );

  const {
    lead,
    configuration,
    activity,
    customer,
    report,
    payment,
    organization,
  } = settings?.ownerForUnassignedEntities || {};

  const ownerEntitiesCompleted =
    !!lead?.salesPerson?.length &&
    !!lead?.crmAgent?.length &&
    !!configuration?.salesPerson?.length &&
    !!configuration?.crmAgent?.length &&
    !!activity?.salesPerson?.length &&
    !!activity?.crmAgent?.length &&
    !!customer?.salesPerson?.length &&
    !!customer?.crmAgent?.length &&
    !!report?.salesPerson?.length &&
    !!report?.crmAgent?.length &&
    !!payment?.salesPerson?.length &&
    !!payment?.crmAgent?.length &&
    !!organization?.salesPerson?.length &&
    !!organization?.crmAgent?.length;

  return (
    <AppLayout>
      <div className="list-head border-bottom py-4 px-3">
        <h2 className="m-0 font-weight-semibold">Visibility Group</h2>
      </div>
      <div className="row no-gutters ch-100">
        <LeftMenu
          tabChangeHandler={handleTabChange}
          tabName={tabName}
          onlineLeadCompleted={
            !!(leadTypes?.length === masterData?.data?.leadTypes?.length)
          }
          ownerEntitiesCompleted={ownerEntitiesCompleted}
        />
        {tabName === TabNames.VisibilityGroups && <VisibilityGroup />}
        {tabName === TabNames.OnlineLeads && (
          <OnlineLeads onReload={reload} settings={settings} />
        )}
        {tabName === TabNames.OwnerUnassignedEntities && (
          <VGOfOnlineUnassignedEntities />
        )}
      </div>
    </AppLayout>
  );
};

export default RolesAcceessibility;
